<div class="carousel-image">
    <img decoding="async" class="img-fluid" [src]="src" alt="">
    <div class="hover-content align-items-center justify-content-center">
        {{text}}
    </div>